module.exports = __webpack_public_path__ + "fonts/la-regular-400.2746742.eot";